// AUTO-GENERATED by `npm run codegen` - do not edit.
namespace $ {

export type demo_note_live_note_likedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type demo_note_live_note_likedSubscription = { __typename?: 'Subscription', note_liked: { __typename?: 'Note', id: string, title: string, likes: number } };


export function $demo_note_live_note_liked(): $demo_graphql_subscription_host<demo_note_live_note_likedSubscription> {
	return $demo_graphql_subscription(`subscription demo_note_live_note_liked {
  note_liked {
    id
    title
    likes
  }
}`, undefined) as $demo_graphql_subscription_host<demo_note_live_note_likedSubscription>
}

}
